import { Button, Group, SegmentedControl, Select, Stack, Text, Title } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';

import { ContentPageOption } from '../hooks/useContentPages';

import { Platform } from '@/features/pages';
import { Departments } from '@/types';

const PLATFORM_LABELS: Record<Platform, string> = {
  instagram: 'Instagram',
  telegram: 'Telegram',
};

type Props = {
  department: Departments;
  platform: Platform;
  onPlatformChange: (platform: Platform) => void;
  pages: ContentPageOption[];
  selectedPageId: string | null;
  onSelectPage: (id: string) => void;
  onAdd: () => void;
};

export const ContentHeader = ({
  department,
  platform,
  onPlatformChange,
  pages,
  selectedPageId,
  onSelectPage,
  onAdd,
}: Props) => {
  const selectedPage = pages.find((page) => page.pageId === selectedPageId);

  return (
    <Group justify="space-between" align="flex-start" mb="lg" wrap="nowrap">
      <Stack gap={4}>
        <Title order={2}>Content</Title>
        <Text size="sm" c="dimmed">
          Регион: {department.toUpperCase()}
          {selectedPage && (
            <>
              {'  •  '}
              {PLATFORM_LABELS[selectedPage.platform]}: {selectedPage.name}
            </>
          )}
        </Text>
      </Stack>
      <Group gap="sm" wrap="nowrap">
        <SegmentedControl
          value={platform}
          onChange={(value) => onPlatformChange(value as Platform)}
          data={[
            { value: 'instagram', label: 'Instagram' },
            { value: 'telegram', label: 'Telegram' },
          ]}
        />
        <Select
          placeholder="Выберите страницу"
          data={pages.map((page) => ({ value: page.pageId, label: page.name }))}
          value={selectedPageId}
          onChange={(value) => value && onSelectPage(value)}
          w={260}
          searchable
          nothingFoundMessage="Страницы не найдены"
        />
        <Button
          leftSection={<IconPlus size={16} />}
          onClick={onAdd}
          disabled={!selectedPageId}
          variant="filled"
        >
          Add new
        </Button>
      </Group>
    </Group>
  );
};
